/** @format */

import {
  MouseOutlined as MouseOutlinedIcon,
  Visibility as VisibilityIcon,
} from '@mui/icons-material';
import {Trans} from 'react-i18next';

import {ShowTypeIcon} from '../../styles';
import {ShowTypeIconProps} from './interfaces';

const ShowTypeIconComponent = ({showType}: ShowTypeIconProps) => {
  if (showType !== 'performance' && showType !== 'media') {
    return (
      <ShowTypeIcon>
        <Trans>-</Trans>
      </ShowTypeIcon>
    );
  }

  return (
    <ShowTypeIcon>
      {showType === 'performance' ? <MouseOutlinedIcon /> : <VisibilityIcon />}
      <Trans>{showType === 'performance' ? 'За клики' : 'За показы'}</Trans>
    </ShowTypeIcon>
  );
};

export default ShowTypeIconComponent;
